/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-12-05 11:33:54
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-02-29 11:15:15
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/api/customPageApi.js
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
 */

import http from '@/utils/http'
// 自定义页面所需接口


// 提交问卷信息
export function getOrderDetail(headers, orderNo) {
  const config = {
    method: 'GET',
    url: `/user/order/ticket/myTicketOrderDetail/${orderNo}`,
    headers
  }
  return http(config)
}



// 上传文件接口
export function upLoadFile(headers, file) {
  const config = {
    method: 'POST',
    url: `/user/file/upload/getUrl`,
    headers,
    data: file
  }
  return http(config)
}

// 生成小程序文件码
export function generateQRCode(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/qr/generateQRCode`,
    headers,
    data,
  }
  return http(config)
}

// 删除健康承诺书
export function delHealthCommitment(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/meeting/admin/delHealthCommitment`,
    headers,
    data,
  }
  return http(config)
}
// 删除遮罩
export function addSupperCode(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/meeting/admin/addSupperCode`,
    headers,
    data,
  }
  return http(config)
}

// 获取用户信息通过手机号
export function getUserByPhone(headers, phone) {
  const config = {
    method: 'GET',
    url: `/user/meeting/admin/getUserByPhone?phone=${phone}`,
    headers
  }
  return http(config)
}

// 操作历史记录
export function operationHistory(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/meeting/admin/operationHistory`,
    headers,
    data,
  }
  return http(config)
}


// 二维码 senceKey参数解析
export function handleSenceQrCode(headers, scene) {
  const config = {
    method: 'GET',
    url: `/user/qr/getQrCodeConfig/${scene}`,
    headers
  }
  return http(config)
}

// 查询 用户个人主页信息
export function queryUserHomePage(headers, uid, language,shareCode) {
  const config = {
    method: 'GET',
    url: `/user/homepage/queryUserHomepage?uid=${uid}&language=${language}&shareCode=${shareCode}`,
    headers
  }
  return http(config)
}






